export const FORCE_PASSWORD_CHANGE_KEY = 'forcePasswordChange';

export function setForcePasswordChangeFlag(value: boolean) {
  if (value) {
    localStorage.setItem(FORCE_PASSWORD_CHANGE_KEY, 'true');
  } else {
    localStorage.removeItem(FORCE_PASSWORD_CHANGE_KEY);
  }
}

export function hasForcePasswordChangeFlag(): boolean {
  return localStorage.getItem(FORCE_PASSWORD_CHANGE_KEY) === 'true';
}

export function getUserInfo(): any {
  const token: string = localStorage.getItem('access_token')

  const base64Url = token.split('.')[1]
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
  const jsonPayload = decodeURIComponent(atob(base64).split('').map( c =>
    '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
  ).join(''))
  
  return JSON.parse(jsonPayload)
}